import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, FormGroup, Input, Label, Row } from 'reactstrap';
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from 'lodash';
import { BOMTypeahead, CollapseTableBom, SpinnerButton } from './';
import { ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

const SITE_OPTIONS = {
   All: 0,
   Plant: 1,
   Warehouse: 2,
};

const TYPE_OPTIONS = {
   All: 0,
   Schedule: 1,
   Item: 2,
};

export default function BomLookup() {
   const [alreadyDisplayed, setAlreadyDisplayed] = useState([]);
   const [exporting, setExport] = useState(false);
   const [item, setItem] = useState(null);
   const [loading, setLoading] = useState(true);
   const [model, setModel] = useState([]);
   const [site, setSite] = useState("PLT");
   const [siteDisplay, setSiteDisplay] = useState("PLT");
   const [siteOpt, setSiteOpt] = useState(1);
   const [typeOpt, setTypeOpt] = useState(1);

   useEffect(() => {
      if (loading) {
         var itm = item?.value ?? "NA";
         api
            .post(`BOM/BomLookup/${typeOpt}/${siteOpt}/${itm}`)
            .then(response => {
               if (response.data.success) {
                  setSiteDisplay(site);
                  setModel(response.data.model);
               }
               else {
                  setModel([]);
                  toast.error(response.data.message);
               }
            })
            .catch((error) => {
               api.catchHandler(error);
               setModel([]);
            })
            .finally(() => {
               setAlreadyDisplayed([]);
               setLoading(false);
            })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loading])

   useEffect(() => {
      if (exporting) {
         var itm = item?.value ?? "NA";
         let url = `Report/ExportBomLookup/${typeOpt}/${siteOpt}/${itm}`;
         api
            .postGetBlob(url, null)
            .then((response) => {
               if (response.data.success === false) {
                  if (_.isString(response?.data?.message)) {
                     toast.error(response?.data?.message);
                  }
               }
               else if (response.data) {
                  let XLSX_FILENAME = `BomLookup.xlsx`;
                  helpers.downloadExport(
                     response.data,
                     XLSX_FILENAME,
                     constants.MIME_TYPES.xlsx
                  );
               } else {
                  toast.error(response.message || "Error downloading report");
               }
            })
            .catch((error) => {
               api.catchHandler(error);
            })
            .finally(() => {
               setExport(false);
            })
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [exporting])

   function handleSiteChange(event) {
      const value = parseInt(event.target.value);
      if (value === 1)
         setSite("PLT");
      else if (value === 2)
         setSite("PLTWHSE");
      else
         setSite("Total");

      setSiteOpt(value);
      setLoading(true);
   };

   function handleTypeahead(opt) {
      if (_.isNil(opt)) {
         setItem(null);
      } else {
         setTypeOpt(TYPE_OPTIONS.Item)
         setItem(opt);
      }
      setLoading(true);
   }

   function handleTypeChange(event) {
      const value = parseInt(event.target.value);
      setTypeOpt(value);
      if (value !== TYPE_OPTIONS.Item) {
         setItem(null);
         setLoading(true);
      }
   };

   const onRowChange = (parent) => {
      let newList = _.cloneDeep(alreadyDisplayed);
      if (_.includes(newList, parent)) {
         setAlreadyDisplayed(_.filter(newList, (x) => x !== parent));
      } else {
         newList.push(parent);
         setAlreadyDisplayed(newList);
      }
   };

   function TableBom({ data, alreadyDisplayed, onChange, site }) {
      const [displayed, setDisplayed] = useState([]);

      useEffect(() => {
         if (!_.isEqual(displayed, alreadyDisplayed)) {
            setDisplayed(alreadyDisplayed);
         }
         // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [alreadyDisplayed])

      return (
         _.map(data, (d, index) => {
            return (
               <CollapseTableBom
                  collapse={_.includes(alreadyDisplayed, d.item)}
                  row={d}
                  itemNum={d.item}
                  onChangeCallback={onChange}
                  key={index}
                  site={site}
               />
            );
         })
      )
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <div className="divCenter800px">
                     <Row style={{ marginBottom: "0px" }}>
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Row className="my-2">
                              <Col sm="10">
                                 <legend className="width115px col-sm-2 h5">
                                    List Type:
                                 </legend>
                                 <FormGroup check inline>
                                    <Label check>
                                       <Input
                                          type="radio"
                                          name="typeOption"
                                          value={TYPE_OPTIONS.Schedule}
                                          checked={typeOpt === TYPE_OPTIONS.Schedule}
                                          onChange={handleTypeChange}
                                       />{" "}
                                       Current Schedule
                                    </Label>
                                 </FormGroup>
                                 <FormGroup check inline>
                                    <Label check>
                                       <Input
                                          type="radio"
                                          name="typeOption"
                                          value={TYPE_OPTIONS.Item}
                                          checked={typeOpt === TYPE_OPTIONS.Item}
                                          onChange={handleTypeChange}
                                       />{" "}
                                       Item
                                    </Label>
                                 </FormGroup>
                              </Col>
                           </Row>

                           <Row className="my-1 mb-0">
                              <Col sm="10">
                                 <legend className="width115px col-sm-2 h5">
                                    Qty Site:
                                 </legend>
                                 <FormGroup check inline>
                                    <Label check>
                                       <Input
                                          type="radio"
                                          name="siteOption"
                                          value={SITE_OPTIONS.All}
                                          checked={siteOpt === SITE_OPTIONS.All}
                                          onChange={handleSiteChange}
                                       />{" "}
                                       ALL
                                    </Label>
                                 </FormGroup>
                                 <FormGroup check inline>
                                    <Label check>
                                       <Input
                                          type="radio"
                                          name="siteOption"
                                          value={SITE_OPTIONS.Plant}
                                          checked={siteOpt === SITE_OPTIONS.Plant}
                                          onChange={handleSiteChange}
                                       />{" "}
                                       PLT
                                    </Label>
                                 </FormGroup>
                                 <FormGroup check inline>
                                    <Label check>
                                       <Input
                                          type="radio"
                                          name="siteOption"
                                          value={SITE_OPTIONS.Warehouse}
                                          checked={siteOpt === SITE_OPTIONS.Warehouse}
                                          onChange={handleSiteChange}
                                       />{" "}
                                       PLTWHSE
                                    </Label>
                                 </FormGroup>
                              </Col>
                           </Row>

                           <Row className="my-2" style={{ paddingBottom: "30px" }}>
                              <Col className="width115px col-sm-2 h5">
                                 <span>Item:</span>
                              </Col>
                              <Col>
                                 <BOMTypeahead inline
                                    value={item}
                                    onChange={opt => handleTypeahead(opt)}
                                    itemGroup={constants.BOM_GROUP.Undefined}
                                    includeSamples={true}
                                 />
                              </Col>
                           </Row>
                        </Col>
                     </Row>
                  </div>

                  <ServiceThreadSpinner on={loading}>
                     {model && model.length ?
                        <>
                           <Row>
                              <Col xs={{ offset: 6, size: 6 }} className="transparent-background">
                                 <SpinnerButton
                                    title="Download as .xlsx"
                                    className="shredButtonExcel float-end ms-2"
                                    onClick={() => setExport(true)}
                                    on={exporting}
                                    disabled={loading || exporting}
                                 >
                                    <FontAwesomeIcon icon="file-excel" size="lg" />
                                 </SpinnerButton>
                              </Col>
                           </Row>
                           <Row className="my-3 px-2">
                              <Col xs="1" className="custom-table-header-top-left"></Col>
                              <Col xs="2" className="table-header py-1">Parent</Col>
                              <Col xs="2" className="table-header py-1">{siteDisplay} On Hand</Col>
                              <Col className="table-header py-1">Setups</Col>
                           </Row>
                           <TableBom data={model} alreadyDisplayed={alreadyDisplayed} onChange={onRowChange} site={siteDisplay} />
                        </>
                        : <div><span>No Bills of Material were found</span></div>
                     }
                  </ServiceThreadSpinner>

               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
